import types from "./types";
import service from "./service";

const getVendors = () => {
    return (dispatch, getState) => {
        dispatch({ type: types.GET_VENDORS });
        service
            .getVendors(getState().vendor.pagination.actualPage, getState().vendor.filters)
            .then(result => {
                dispatch(getAllSuccess(result.list));
                dispatch(updatePagination(result.pagination));
            })
            .catch(err => dispatch(getAllFail(err)));
    };
};

const changePage = page => {
    return dispatch => {
        dispatch(changeVendorPage({ page: page }));
        dispatch(getVendors());
    };
};
const updateFilter = filters => {
    return dispatch => {
        dispatch(changeFilters(filters));
        dispatch(changeVendorPage({ page: 1 }));
        dispatch(getVendors());
    };
};

const changeFilters = payload => ({
    type: types.FILTER_LIST,
    payload
});

const changeVendorPage = payload => ({
    type: types.CHANGE_PAGE,
    payload
});

const getAllSuccess = payload => ({
    type: types.GET_VENDORS_SUCCESS,
    payload
});
const getAllFail = error => ({
    type: types.GET_VENDORS_FAIL,
    payload: error
});

const updatePagination = payload => ({
    type: types.UPDATE_PAGINATION,
    payload
});

export default {
    getVendors,
    changePage,
    updateFilter
};
